export default "__VITE_ASSET__7zwUeg1E__"